import ContractsService from '@/api/ContractsService.js'
import Vue from 'vue'
export const contractsModule = {
  namespaced: true,
  state: () => ({
    contractsData: [],
    contractsLoadStatus: 'request',
    paginationContractsStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationContractsStateParams.total /
        state.paginationContractsStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.contractsData = [...data]
    },
    create(state, data) {
      state.contractsData.unshift(data)
    },
    edit_multiple(state, data) {
      let indexed = state.contractsData.findIndex(
        (x) => x.contracts__id == data.id
      )
      Object.assign(state.contractsData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.contractsData.findIndex((x) => x.contracts__id == id)
      state.contractsData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationContractsStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.contractsLoadStatus = 'request'
    },
    load_success(state) {
      state.contractsLoadStatus = 'success'
    },
    load_error(state) {
      state.contractsLoadStatus = 'error'
    }
  },
  actions: {
    getContractsAll({ commit }, params) {
      commit('load_request')

      ContractsService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createContractsData({ commit }, createData) {
      ContractsService.create(createData)
        .then((data) => {
          commit('create', data.data.data)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editContractsMultiple({ commit }, { id, dataEdit, callback }) {
      ContractsService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
          if (callback) {
            callback()
          }

          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    deleteContractsData({ commit }, id) {
      // commit("load_request");
      ContractsService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
